import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

const GridDepartamentos = ({ contas, codigoRateio, onRemover, disabled }) => {
  if (!contas || contas.length === 0) {
    return (
      <p className="text-muted text-center py-3 mb-0 small">
        Nenhum departamento adicionado. Use o formulário abaixo para adicionar.
      </p>
    );
  }

  return (
    <Table striped bordered hover size="sm" className="mb-0">
      <thead>
        <tr>
          <th>Departamento</th>
          <th style={{ width: '110px', textAlign: 'center' }}>Percentual (%)</th>
          <th style={{ width: '70px', textAlign: 'center' }}>Remover</th>
        </tr>
      </thead>
      <tbody>
        {contas.map((conta, idx) => (
          <tr key={`${codigoRateio || 'novo'}-${conta.departamento}`}>
            <td>{conta.descricao_depto || `Depto ${conta.departamento}`}</td>
            <td style={{ textAlign: 'center' }}>
              {Number(conta.percentual).toFixed(2)}
            </td>
            <td style={{ textAlign: 'center' }}>
              <Button
                size="sm"
                variant="outline-danger"
                disabled={disabled}
                onClick={() => onRemover(idx)}
                title="Remover departamento"
              >
                <FaTrash />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default GridDepartamentos;
